import React from 'react';
import classNames from 'classnames';
import { Link } from '../Link';
import { PumoModuleSlideFragment } from '../../generated/types/PumoModuleSlideFragment';
import { PumoModuleSlideContent } from './PumoModuleSlideContent';

import './PumoModuleSlide.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  slide: PumoModuleSlideFragment;
  cover?: boolean;
  beforeEyebrow?: React.ReactNode;
  afterEyebrow?: React.ReactNode;
  normalizePumoStyles?: boolean;
}

export const PumoModuleSlide: React.FC<Props> = props => {
  const { slide, className } = props;
  if (!slide) return null;

  return (
    <div className={classNames('PumoModuleSlide', className)}>
      {slide.ctaUrl ? (
        <Link aria-label={`Go to ${slide.ctaUrl}`} to={slide.ctaUrl}>
          <PumoModuleSlideContent {...props} />
        </Link>
      ) : (
        <PumoModuleSlideContent {...props} />
      )}
    </div>
  );
};
